<script setup lang="ts">
import { ref, watch } from 'vue';
import NavBarDrawerContent from './NavBarDrawerContent.vue';
import MenuSVG from '@shared/assets/icon/menu.svg';
import XmarkSVG from '@shared/assets/icon/xmark.svg';
import logo from '@shared/assets/png/allume_logo_2024.png';
import { useCommissioningNavStore } from '@/modules/commissioning/stores/commissioningNavStore';

const showOverlay = ref(false);
const toggleOverlay = () => {
  showOverlay.value = !showOverlay.value;
};

const commissioningNavStore = useCommissioningNavStore();
watch(
  () => commissioningNavStore.contactUsViaNavRequested,
  (requested) => {
    if (requested) {
      showOverlay.value = true;
    }
  },
);
</script>

<template>
  <a-row type="flex" justify="space-around" align="middle" class="nav">
    <a-col :span="2">
      <MenuSVG
        v-show="!showOverlay"
        class="nav-btn svg-icon"
        data-tn="nav-bar-expand"
        @click="toggleOverlay"
      />

      <XmarkSVG
        v-show="showOverlay"
        class="nav-btn svg-icon"
        data-tn="nav-bar-close"
        @click="toggleOverlay"
      />
    </a-col>

    <a-col :span="12">
      <img :src="logo" alt="Allume Energy logo" class="nav__logo" height="38" />
    </a-col>

    <a-col :span="10"></a-col>
  </a-row>
  <NavBarDrawerContent v-model:visible="showOverlay" />
</template>

<style lang="less" scoped>
.nav {
  background: @color-primary;
  color: #fff;
  height: @com-nav-height;
  box-shadow: 0 0.2px 15px rgba(0, 0, 0, 0.5);
  padding: 0 20px;

  .nav-btn {
    cursor: pointer;
    color: #fff;
  }

  .nav__logo {
    margin: 5px;
  }

  .hidden {
    visibility: hidden;
  }

  .blink {
    animation-timing-function: ease-in-out;
    animation-name: breathe;
    animation-duration: 0.8s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }
}

@-webkit-keyframes breathe {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes breathe {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
